import Typography from "../Typography";

type PreviousSelectionsTextProps = {
    label: string;
    value: string;
};

const PreviousSelectionsText = ({
    label,
    value,
}: PreviousSelectionsTextProps) => {
    return (
        <span>
            <Typography variant="label-medium" component="label">
                {label}
            </Typography>
            <Typography variant="body-small" component="p">
                {value}
            </Typography>
        </span>
    );
};

export default PreviousSelectionsText;
